import { DownloadIcon, EllipsisVerticalIcon, UploadIcon } from 'lucide-react'
import type { ChangeEvent, ReactNode } from 'react'
import { useRef } from 'react'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

interface AgencyFlowExportImportDropdownProps {
  onExport: () => void
  onImport: (file: File) => void
}

export const AgencyFlowExportImportDropdown = ({
  onExport,
  onImport,
}: AgencyFlowExportImportDropdownProps): ReactNode => {
  const fileInputRef = useRef<HTMLInputElement>(null)

  const handleImportClick = (): void => {
    fileInputRef.current?.click()
  }

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const file = event.target.files?.[0]
    if (!file) return

    onImport(file)

    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="agency-flow-export-import-trigger">
          <EllipsisVerticalIcon className="size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={onExport} className="agency-flow-export-button">
          <DownloadIcon className="mr-2 size-4" />
          Export
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleImportClick} className="agency-flow-import-button">
          <UploadIcon className="mr-2 size-4" />
          Import
        </DropdownMenuItem>
      </DropdownMenuContent>
      <input
        ref={fileInputRef}
        type="file"
        accept=".json"
        onChange={handleFileChange}
        className="hidden"
        tabIndex={-1}
      />
    </DropdownMenu>
  )
}

AgencyFlowExportImportDropdown.displayName = 'AgencyFlowExportImportDropdown'
